import { render, staticRenderFns } from "./ReportAbsencesOverview.vue?vue&type=template&id=0d5be7b6&scoped=true&"
import script from "./ReportAbsencesOverview.vue?vue&type=script&lang=js&"
export * from "./ReportAbsencesOverview.vue?vue&type=script&lang=js&"
import style0 from "./ReportAbsencesOverview.vue?vue&type=style&index=0&id=0d5be7b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5be7b6",
  null
  
)

export default component.exports